import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
 import CustomerMasterLayout from "../../../layouts/Customer/CustomerMasterLayout";
import "../../../assets/css/Customer/CustomerCategories/CustomerCategories.css";

const CustomerCategories = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 1,
      title: "Instant Ride",
      description: "Need a ride? Book instantly and get moving in minutes",
      route: "/customer-instant-ride", // Route lazmi add karein
    },
    {
      id: 2,
      title: "City to City",
      description: "Used for travel city to city",
      route: "/customer-ride-selection", // Route lazmi add karein
    },
  ];

  const handleCategoryClick = (route) => {
    if (route) navigate(route);
  };

  return (
    <CustomerMasterLayout screenName="Categories">
      <Container fluid className="CustomerCategories-container">
        <Row className="CustomerCategories-row">
          {categories.map((category) => (
            <Col xs={12} key={category.id} className="CustomerCategories-col">
              <Card
                className="CustomerCategories-card"
                onClick={() => handleCategoryClick(category.route)}
                style={{ cursor: "pointer" }}
              >
                <Card.Body className="CustomerCategories-card-body">
                  <div className="CustomerCategories-card-content">
                    <div className="CustomerCategories-card-left">
                      <h3 className="CustomerCategories-card-title">
                        {category.title}
                      </h3>
                      <p className="CustomerCategories-card-description">
                        {category.description}
                      </p>
                      <Button variant="link" className="CustomerCategories-arrow-btn">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M5 12H19M19 12L12 5M19 12L12 19"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                    <div className="CustomerCategories-card-right"></div>
                  </div>
                  <div className="CustomerCategories-pattern"></div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </CustomerMasterLayout>
  );
};

export default CustomerCategories;